/* eslint-disable @typescript-eslint/naming-convention */
interface ILoggedInUser {
  id: string;
  designation: {
    paneltype: string;
  };
  mainSuperAdminId: string;
  accessToken: string;
  name: string;
  email: string;
  picture: string | null;
  number: string;
  pages: string;
  commentPages: string;
  pseudonym: string;
  username: string;
  stripe_id: string;
  verified: number;
  facebookId: string;
  plans: string;
  endDate: string;
  hasTrial: string;
  subscriptionId: string;
  currentCount: number;
  maxCount: number;
  currentDeletedCount: number;
  stripe_subscription_status: string;
  new_plan: string;
  new_plan_status: string;
  plan_change_effective_date: string | null;
  plan_change_type: string | null;
  customFeatures: any;
  billingOnly: boolean;
}

const setAuthDataInLocalStorage = (user: ILoggedInUser): boolean => {
  if (!user) return false;
  try {
    const {
      id,
      designation,
      mainSuperAdminId,
      name,
      email,
      accessToken,
      picture,
      number,
      pseudonym,
      username,
      stripe_id,
      plans,
      verified,
      facebookId,
      hasTrial,
      endDate,
      subscriptionId,
      pages,
      commentPages,
      //
      currentCount,
      maxCount,
      currentDeletedCount,
      stripe_subscription_status,
      new_plan,
      new_plan_status,
      plan_change_effective_date,
      plan_change_type,
      customFeatures,
      billingOnly,
    } = user;
    const paneltype = designation?.paneltype;
    localStorage.setItem("userName", name);
    const ActiveUserData = {
      id,
      paneltype,
      mainSuperAdminId,
      picture,
      number,
      pseudonym,
      username,
      email,
      stripe_id,
      verified,
      facebookId,
      plans,
      hasTrial,
      endDate,
      subscriptionId,
      //
      pages,
      commentPages,
      //
      currentCount,
      maxCount,
      currentDeletedCount,
      stripe_subscription_status,
      //
      new_plan,
      new_plan_status,
      plan_change_effective_date,
      plan_change_type,
      //
      customFeatures,
      billingOnly,
    };
    localStorage.setItem("ActiveUserdetail", JSON.stringify(ActiveUserData));
    if (accessToken) localStorage.setItem("accessToken", accessToken);
    return true;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Error while setting data in localStorage:", err);
    return false;
  }
};

export default setAuthDataInLocalStorage;
